import React from 'react';
import { Accordion } from '~/components/Accordion/Accordion';
import { AccordionItem } from '~/components/Accordion/AccordionItem';
import { StyledFaqBlock } from './FaqBlock.styled';
import { FaqQuestion } from '~/pages/faq';
import { Helmet } from 'react-helmet';

export const FaqBlock: React.FC<FaqBlockProps> = ({ questions, generateSchema = true }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": (questions || []).map(q => {
      return {
        "@type": "Question",
        "name": q.question.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": q.answer.childMarkdownRemark.html,
        },
      };
    })    
  }
  return (
    <StyledFaqBlock>
      {generateSchema && <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>}
      <Accordion>
        {questions.map(q => {
          return (
            <AccordionItem key={`question-${q.id}`} title={q.question.question}>
              <div
                className="answer"
                dangerouslySetInnerHTML={{
                  __html: q.answer.childMarkdownRemark.html,
                }}
              />
            </AccordionItem>
          );
        })}
      </Accordion>
    </StyledFaqBlock>
  );
};

interface FaqBlockProps {
  questions: FaqQuestion[];
  generateSchema?: boolean;
}
